<template>
  <section class="colofon">
    <SuccessMessage></SuccessMessage>
    <div class="blobs"></div>
    <div class="top content-div">
      <Container>
        <Title
          dark
          small
          class="center"
        >
          Deel dit verhaal
        </Title>
        <Share></Share>
      </Container>
    </div>
    <div class="middle content-div center">
      <Container>
        <Title
          dark
          small
          class="center smaller-width"
        >
          Wat vond je van deze special?
        </Title>
        <ThumbButtons></ThumbButtons>
        <a
          class="button"
          href="https://surveys.enalyzer.com/?pid=b6uf4man"
          target="_blank"
        >
          Stuur feedback
        </a>
      </Container>
    </div>
    <div class="middle content-div">
      <Container>
        <Title dark small>Colofon</Title>
        <Content dark small>
          <p>
            <b>
              Redactie:
            </b>
            <br />
            Nick Felix, Jeanine Duijst, Melvin Captein
          </p>
          <p><b>Design &amp; code:</b><br>Vincent Wielders, Robbert Lokhorst, Mariette Twilt, Tim van Steenbergen</p>
        </Content>
      </Container>
    </div>
    <div class="bottom content-div">
      <Container>
        <Title dark small>Verantwoording + bronnen</Title>
        <Content dark small>
          <p>Voor de teksten hebben we gesproken met verschillende jongeren die een depressie hebben gehad. Van zes van hen hebben we het verhaal vastgelegd in interviews. We hebben hun ervaringen zo getrouw mogelijk proberen weer te geven, maar een depressie blijft iets individueels.</p>
          <p>Om de verhalen te toetsen en in een bredere context te plaatsen hebben we uitgebreid contact gehad met psychotherapeut Yvonne Stikkelbroek. Zij is verbonden aan de Universiteit Utrecht en gespecialiseerd in depressies bij jongeren.</p>
          <p>We hebben ook een grote hoeveelheid geschreven bronnen geraadpleegd, waaronder de DSM-5 en cijfers gebruikt van het EenVandaag Jongerenpanel en het CBS.</p>
        </Content>
      </Container>
    </div>
  </section>
</template>

<script>
import { Title, Content, Container } from '@/components/chapter'
import { Share, SuccessMessage } from '@/components/share'
import { ThumbButtons } from '@/components/thumbs'
import { chapterMixin } from '@/mixins'

export default {
  name: 'Colofon',
  mixins: [chapterMixin],
  components: {
    Title,
    Content,
    Share,
    Container,
    ThumbButtons,
    SuccessMessage
  }
}
</script>

<style lang="scss" scoped>
.colofon {
  background-color: #1E1E1E;
  padding-top: 77px;
  padding-bottom: 135px;
  position: relative;
  margin-top: 166px;

  @media (min-width: 768px) {
    padding-top: 104px;
  }

  &:before {
    content: '';
    background-image: url(~@/assets/images/border.png);
    background-size: 740px 166px;
    background-repeat: repeat;
    background-position: top center;
    height: 166px;
    left: 0;
    right: 0;
    top: -166px;
    position: absolute;
    z-index: 1;
  }
}
.blobs {
  &:before, &:after {
    content: '';
    position: absolute;
    background-image: url(~@/assets/images/blob.png);
    background-size: 485px 331px;
    width: 485px;
    height: 331px;
    background-repeat: no-repeat;
    background-position: top left;
    z-index: 1;
    background-blend-mode: screen;
    mix-blend-mode: screen;
  }
  &:before {
    top: 800px;
    left: -220px;
  }
  &:after {
    top: 150px;
    right: -170px;
  }

  @media (max-width: 800px) {
    display: none;
  }
}
.top {
  margin-bottom: 72px;
}
.middle {
  margin-bottom: 98px;
}
.bottom {
}
.center {
  text-align: center;
}
.smaller-width {
  max-width: 287px;
  margin-left: auto;
  margin-right: auto;
}
.button {
  font-size: 20px;
  font-weight: $fw-medium;
  line-height: 2.7;
  text-align: center;
  color: white;
  border-radius: 27.5px;
  min-width: 226px;
  border: 1px solid white;
  display: inline-block;
  margin-top: 44px;

  &:hover, &:visited, &:focus, &:active {
    color: white;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/chapters/Colofon.vue